import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { resolveAnonymousLanguage } from '../lib/storedLanguage'
import deApp from '../locales/partials/app.de.json'
import deCalendar from '../locales/partials/calendar.de.json'
import deCoach from '../locales/partials/coach.de.json'
import deCoachInsights from '../locales/partials/coach-insights.de.json'
import deMeals from '../locales/partials/meals.de.json'
import deOnboarding from '../locales/partials/onboarding.de.json'
import dePredictive from '../locales/partials/predictive.de.json'
import dePrivacy from '../locales/partials/privacy.de.json'
import deShopping from '../locales/partials/shopping.de.json'
import deWorkout from '../locales/partials/workout.de.json'
import enApp from '../locales/partials/app.en.json'
import enCalendar from '../locales/partials/calendar.en.json'
import enCoach from '../locales/partials/coach.en.json'
import enCoachInsights from '../locales/partials/coach-insights.en.json'
import enMeals from '../locales/partials/meals.en.json'
import enOnboarding from '../locales/partials/onboarding.en.json'
import enPredictive from '../locales/partials/predictive.en.json'
import enPrivacy from '../locales/partials/privacy.en.json'
import enShopping from '../locales/partials/shopping.en.json'
import enWorkout from '../locales/partials/workout.en.json'
import frApp from '../locales/partials/app.fr.json'
import frCalendar from '../locales/partials/calendar.fr.json'
import frCoach from '../locales/partials/coach.fr.json'
import frCoachInsights from '../locales/partials/coach-insights.fr.json'
import frMeals from '../locales/partials/meals.fr.json'
import frOnboarding from '../locales/partials/onboarding.fr.json'
import frPredictive from '../locales/partials/predictive.fr.json'
import frPrivacy from '../locales/partials/privacy.fr.json'
import frShopping from '../locales/partials/shopping.fr.json'
import frWorkout from '../locales/partials/workout.fr.json'
import de from '../locales/de.json'
import en from '../locales/en.json'
import fr from '../locales/fr.json'
import { DEFAULT_LANGUAGE } from './languages'

function deepMerge<T extends Record<string, unknown>>(...objects: T[]): T {
  const result: Record<string, unknown> = {}

  for (const obj of objects) {
    for (const [key, value] of Object.entries(obj)) {
      const existing = result[key]
      if (
        value &&
        typeof value === 'object' &&
        !Array.isArray(value) &&
        existing &&
        typeof existing === 'object' &&
        !Array.isArray(existing)
      ) {
        result[key] = deepMerge(existing as Record<string, unknown>, value as Record<string, unknown>)
      } else {
        result[key] = value
      }
    }
  }

  return result as T
}

const resources = {
  en: {
    translation: deepMerge(
      en as Record<string, unknown>,
      enOnboarding as Record<string, unknown>,
      enCoach as Record<string, unknown>,
      enCoachInsights as Record<string, unknown>,
      enMeals as Record<string, unknown>,
      enShopping as Record<string, unknown>,
      enPredictive as Record<string, unknown>,
      enCalendar as Record<string, unknown>,
      enPrivacy as Record<string, unknown>,
      enWorkout as Record<string, unknown>,
      enApp as Record<string, unknown>,
    ),
  },
  de: {
    translation: deepMerge(
      de as Record<string, unknown>,
      deOnboarding as Record<string, unknown>,
      deCoach as Record<string, unknown>,
      deCoachInsights as Record<string, unknown>,
      deMeals as Record<string, unknown>,
      deShopping as Record<string, unknown>,
      dePredictive as Record<string, unknown>,
      deCalendar as Record<string, unknown>,
      dePrivacy as Record<string, unknown>,
      deWorkout as Record<string, unknown>,
      deApp as Record<string, unknown>,
    ),
  },
  fr: {
    translation: deepMerge(
      fr as Record<string, unknown>,
      frOnboarding as Record<string, unknown>,
      frCoach as Record<string, unknown>,
      frCoachInsights as Record<string, unknown>,
      frMeals as Record<string, unknown>,
      frShopping as Record<string, unknown>,
      frPredictive as Record<string, unknown>,
      frCalendar as Record<string, unknown>,
      frPrivacy as Record<string, unknown>,
      frWorkout as Record<string, unknown>,
      frApp as Record<string, unknown>,
    ),
  },
}

void i18n.use(initReactI18next).init({
  resources,
  lng: resolveAnonymousLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: ['en', 'de', 'fr'],
  nonExplicitSupportedLngs: true,
  interpolation: {
    escapeValue: false,
  },
})

if (typeof document !== 'undefined') {
  document.documentElement.lang = i18n.language
}

export default i18n
